export const interestOptions = [
  {
    value:
      "A company outside Egypt interested to hire a team with Remotecoders",
  },
  {
    value:
      "A company based in Egypt interested to hire talents from Remotecoders",
  },
  {
    value: "Interested to learn more how to apply as a trainee at Remotecoders",
  },
  {
    value: "A senior developer interested to work for Remotecoders",
  },
  {
    value: "Other",
  },
];
